const pt = {
    ATTRIBUTES: 'Atributos',
    ATTRIBUTE_PLACEHOLDER: 'Selecionar um atributo',
    CONDITIONAL: 'Condicional',
    CONDITIONAL_PLACEHOLDER: 'Selecionar uma condição',
    VALUE: 'Valor',
    VALUE_PLACEHOLDER: 'Digite um valor',
    TAG_PLACEHOLDER: 'Selecionar uma etiqueta',
    VIEW_USERS_IN_SEGMENT: 'Ver usuários no segmento',
    CLEAR_ALL: 'Limpar todo',
    ADD_RULE: 'Adicionar regra',
    DELETE_ALL: 'Excluir tudo',
    DATE: 'Data',
    SEARCH_PLACEHOLDER: 'Pesquisar...',
    NO_RESULTS: 'Nenhum resultado encontrado',
    ERROR_FETCHING_VALUES: 'Erro ao buscar valores do atributo'
};
export { pt };
